var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vame',{on:{"update":_vm.update}},[_c('div',{staticClass:"note"},[_c('small',[_vm._v("WASD or Arrow Keys to move.")])]),_c('keyboard-input',{attrs:{"key-map":{
      curUp: [ 'w', 'arrowup' ],
      curDown: [ 's', 'arrowdown' ],
      curLeft: [ 'a', 'arrowleft' ],
      curRight: [ 'd', 'arrowright' ]
    }},on:{"keydown":_vm.keydown}}),_c('renderer',{attrs:{"scale":3,"pixel-scale":6,"clear-color":'#fff',"use-ecs":true,"ecs-render-components":_vm.renderComponents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }